import { messaging } from './FirebaseConfig';
import { getToken, onMessage } from 'firebase/messaging';
import { gql } from '@apollo/client';

// GraphQL mutation for updating FCM token
export const UPDATE_FCM_TOKEN = gql`
  mutation UpdateFcmToken($payload: UpdateFcmTokenDto!) {
    updateFcmToken(payload: $payload) {
      message
    }
  }
`;

// Request notification permission and get FCM token
export const requestPermissionAndGetToken = async (apolloClient) => {
  try {
    // Request permission for notifications
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      console.log('Notification permission granted.');
 
      const token = await getToken(messaging, { 
        vapidKey: 'BOiOpxd9EfJWGG7DZAbUQJ0kp3nR-PAItOf3vMDGc0m9ZSHiaJJCRvfaVvfzMPOFJE1tdWX3EVBikmPSD_Wd4WU' 
      });
      
      if (token) {
        console.log('FCM Token:', token);
        
        // Send token to your GraphQL server
        try {
          const response = await apolloClient.mutate({
            mutation: UPDATE_FCM_TOKEN,
            variables: {
              payload: {
                fcmToken: token
              }
            }
          });
          
          console.log('FCM token updated successfully:', response.data);
          return token;
        } catch (error) {
          console.error('Error updating FCM token:', error);
          throw error;
        }
      } else {
        console.log('No registration token available.');
        return null;
      }
    } else {
      console.log('Unable to get permission to notify.');
      return null;
    }
  } catch (error) {
    console.error('An error occurred while retrieving token or requesting permission:', error);
    throw error;
  }
};

// Listen for foreground messages
export const setupForegroundMessageListener = () => {
  onMessage(messaging, (payload) => {
    console.log('Message received in foreground:', payload);
    
    // Handle different message formats
    let title, body, icon;
    
    if (payload.notification) {
      // Standard notification format
      title = payload.notification.title;
      body = payload.notification.body;
      icon = payload.notification.icon;
    } else if (payload.data) {
      // Data-only message format
      title = payload.data.title || 'New Notification';
      body = payload.data.body || 'You have a new message';
      icon = payload.data.icon;
    } else {
      // Fallback
      title = 'New Notification';
      body = 'You have a new message';
    }
    
    console.log('Displaying notification:', { title, body, icon });
    
    // Check if browser supports notifications
    if ('Notification' in window && Notification.permission === 'granted') {
      try {
        const notification = new Notification(title, {
          body: body,
          icon: icon || '/favicon.ico',
          badge: '/favicon.ico',
          tag: 'firebase-notification',
          requireInteraction: true,
          silent: false
        });
        
        // Handle notification click
        notification.onclick = function(event) {
          event.preventDefault();
          window.focus();
          notification.close();
        };
        
        // Auto close after 5 seconds if not clicked
        setTimeout(() => {
          notification.close();
        }, 5000);
        
      } catch (error) {
        console.error('Error displaying notification:', error);
        
        // Fallback: show alert if notification fails
        alert(`${title}: ${body}`);
      }
    } else {
      console.warn('Notifications not supported or permission not granted');
      // Fallback: show alert
      alert(`${title}: ${body}`);
    }
  });
};

// Test notification function
// export const testNotification = () => {
//   console.log('Testing notification...');
//   console.log('Notification permission:', Notification.permission);
//   console.log('Notification support:', 'Notification' in window);
  
//   if ('Notification' in window && Notification.permission === 'granted') {
//     try {
//       const notification = new Notification('Test Notification', {
//         body: 'This is a test notification to verify functionality',
//         icon: '/favicon.ico',
//         tag: 'test-notification'
//       });
      
//       notification.onclick = function() {
//         window.focus();
//         notification.close();
//       };
      
//       setTimeout(() => {
//         notification.close();
//       }, 5000);
      
//       console.log('Test notification created successfully');
//     } catch (error) {
//       console.error('Failed to create test notification:', error);
//     }
//   } else {
//     console.error('Notification permission not granted or not supported');
//   }
// };

// Check notification permission status
export const checkNotificationPermission = () => {
  const status = {
    supported: 'Notification' in window,
    permission: Notification.permission,
    canShow: 'Notification' in window && Notification.permission === 'granted'
  };
  
  console.log('Notification status:', status);
  return status;
};

// Export messaging for other uses
export { messaging };
